import React,{ useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row, Nav, Container, Tab} from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from 'react-router-dom';
import { auth } from "../config/Config";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import Sidebar from './SidebarNav';

export default function Factory() {
  const navigation = useNavigate();
  
  const { userData, userLoader, userError} = useSelector((state)=>state.viewusers);
  const handleLogOut =()=>{
    auth.signOut();
    // navigation('/login');
  }
// useEffect(()=>console.log('ffff', data), []);
  useEffect(()=>{
  auth.onAuthStateChanged(user => {
    const routeName = user !== null ? '/factory' : '/login';
    navigation(routeName);
  });
}, []);
  return (
    <Container fluid>
    <Row>
    <Col sm={1} style={{ backgroundColor: '#fdc771' }}>
          <Tab.Container  >
            <Row>
            </Row>
          </Tab.Container>
        </Col>
      <Col sm={11} className="m-0">
        <Row>
          <Col style={{
                backgroundColor: "#f5f8f8",
                display: "flex",
                flexDirection: "row",
                padding: "1%",
                justifyContent: "space-between",
              }}>
              <Col sm={10}>
              <p style={{ fontSize: 20, fontWeight: "bold" }}>Factory</p>
              </Col>
            
              <Col sm={2}>
                <img
                  src={require("../assests/notification.png")}
                  alt="Notification"
                  style={{ width: 26, height: 26 }}
                />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Dropdown className="d-inline mx-2">
                  <Dropdown.Toggle id="dropdown-autoclose-true">
                    <img
                      src={require("../assests/user.png")}
                      alt="User"
                      style={{ width: 40, height: 40 }}
                    />{" "}
                    &nbsp;&nbsp; {userData ? userData[0].name : "UNKNOWN"} &nbsp;
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item href="#">
                      <Link to={"/viewprofile"}>View Profile</Link>
                    </Dropdown.Item>
                    <Dropdown.Item href="#">FAQ</Dropdown.Item>
                    <Dropdown.Item  onClick={()=>handleLogOut()}>Logout</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
          </Col>
        </Row>
        <Row className="p-5">
          
         
        </Row>
      </Col>
    </Row>
  </Container>
  );
}


